import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import FileSaver from 'file-saver';
import {  MessageService } from 'primeng/api';
import { UserService } from 'src/app/Admin/Authorization/UserRoleMapping/Services/user.service';
import { ContractService } from 'src/app/Contracts/Services/contract.service';
import { FinanceService } from 'src/app/Finance/Services/invoice.service';
import { LoaderService } from 'src/app/Loader/loader.service';
import { SponserService } from 'src/app/MasterData/Services/sponser.service';
import { CurrencyService } from 'src/app/Reusable/currency.service';
import { PrivilegeService } from 'src/app/Reusable/privilege.service';
import {  CodeList, CodeListStatusTypes, Dateformat, FileExtension, StatusCodes, AuditIdentifier, AuditLogModule } from 'src/app/shared/constants/global.constants';
import { AuditLogService } from 'src/app/shared/ModelComparison/audit.log.service';
import { Privileges } from 'src/app/shared/constants/privileges.constants';
import { TabAndStateService } from 'src/app/shared/TabAndStateService/TabAndState.Service';
import {  } from 'src/environments/environment';
import { ContracDetails } from '../../../../Models/contract-accrual';


@Component({
  selector: 'app-con-volume-list',
  templateUrl: './con-volume-list.component.html',
  styleUrls: ['./con-volume-list.component.css']
})
export class ConVolumeListComponent implements  OnInit {
  codelist: any[] = [] ;
  @Output() editButtonClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() viewButtonClick: EventEmitter<any> = new EventEmitter<any>();

  @Output() childData: EventEmitter<any> = new EventEmitter<any>();
 
  @Input() ContractId:any;
  @Input() contractStartDate:any;
  @Input() SupplierId: any;
  @Input() SponsorId: any;
  @Input() EngagementName: any;
  @Input() productApplicability : any;

  date: Date | undefined;
  codeListStatusTypes: any;
  codeListValues:any;
  statusCodes:any;
  statusData:any;
  // SelectedStatus:any;
 selectedVolumes: any;
StatusName: any[] = [];
invoiceData:any;
_dateformart :any;
status:any;
uniqueStatusNames: string[] = [];
isChecked: boolean = true;
  editPrivilege:boolean=false;
  viewPrivilege:boolean=false;
  ExportPrivilege:boolean=false;
  totalRecordCount: number = 0;
  filteredRecordCount: number = -1;
  constructor(private privilegeService: PrivilegeService,private datePipe: DatePipe,
    private router:Router,private loaderService: LoaderService,private masterDataService: SponserService,
    private _financeInvoiceService:FinanceService,private route: ActivatedRoute,
    private currencyService: CurrencyService, private fb: FormBuilder, private messageService: MessageService,
    private contractService: ContractService,
    private tabAndStateService: TabAndStateService,private _userService:UserService, private auditLogService: AuditLogService, ){
   
  }

  currency:any;
  userId:any;
  ngOnInit() {
 
    var userData=this.privilegeService.getUserData();
    this.userId=userData.id;
    this.GetUsersList();
    this.codeListValues=CodeList;
    this.codeListStatusTypes=CodeListStatusTypes
    this.GetVolumeStatus(this.codeListValues.Tbl_Status, this.codeListStatusTypes.VOLSTS);
    this.statusCodes=StatusCodes;
    
     this._dateformart=Dateformat;
     this.BindPrivileges();
     this.currency= this.route.snapshot.queryParamMap.get('currency');
    if(!this.currency){
      this.currency= this.route.snapshot.paramMap.get('currency')
    }
     this.GetContractDetailsByContractId(this.ContractId);
    
}

BindPrivileges(){
  const hasPermission = (privilege: Privileges) => this.privilegeService.hasPermission(privilege);
   this.editPrivilege = hasPermission(Privileges.EditVolume);
   this.viewPrivilege = hasPermission(Privileges.ViewVolume);
   this.ExportPrivilege = hasPermission(Privileges.ExportVolume);  
  }
    usersList:any;
    GetUsersList(){
    this._userService.GetUserViewDetailsById(this.userId).subscribe((res:any)=>{
      if(res.status){

      this.usersList=res.data.groupId;
      }
    })

    }
GetVolumeStatus(enumId: number, type: string) { 
  this.masterDataService.getCodeListData(enumId, type).subscribe(
    res => {
      if (res.data.length > 0) {
        this.statusData = res.data;
        this.populateStatusNames();    
      }
    }
  );
};


getStatusName(statusId: number): string {
  this.status = this.statusData.find((s: { id: number; }) => s.id === statusId);
  return this.status ? this.status.name : 'Unknown'; 
}

populateStatusNames() {
  const uniqueStatusNames1: any[] = [];
  this.statusData.forEach((invoice: any) => {
    const statusMappingId = invoice.id;
    if (uniqueStatusNames1.findIndex(item => item.value === statusMappingId) === -1) {
      uniqueStatusNames1.push({
        label: this.getStatusName(statusMappingId),
        value: statusMappingId,
      });
    }
  });
  setTimeout(() => {
    this.StatusName = uniqueStatusNames1;
  }, 2000);
}


viewInvoice(rowData:any){
   const dataResult = {
    contractid:this.ContractId,
    invoiceId:rowData.id
  };
  this.viewButtonClick.emit(dataResult);
}

CheckboxEnabled() {
  if (this.selectedVolumes.length > 0) {
    this.isChecked = false;
  }
  else {
    this.isChecked = true;
  }
}

exportExcel(SelectedRecords: any) {
  import('xlsx').then((xlsx) => {
    const worksheet = xlsx.utils.json_to_sheet(SelectedRecords);
    const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
    const fileName = `${this.contractInfo.title} - Contract Volume Export - ${this.convertFileDateFormat(Date())}.xlsx`;
    this.saveAsExcelFile(excelBuffer, fileName);
  });
}

saveAsExcelFile(buffer: any, fileName: string): void {
  this.auditLogService.logExportWithFilters('Volumes',AuditIdentifier.ContractVolumes,AuditLogModule.FinanceService,fileName,{
    'Contract': this.contractInfo?.title
  });

  let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  let EXCEL_EXTENSION = FileExtension.ExportExtention;
  const data: Blob = new Blob([buffer], {
    type: EXCEL_TYPE
  });
  FileSaver.saveAs(data, fileName);
}
selectedRecordsToExpotToExcel: any[] = [];
exportContractVolumes() {
  this.selectedRecordsToExpotToExcel = this.selectedVolumes;
  this.selectedRecordsToExpotToExcel = this.selectedRecordsToExpotToExcel.map((volume) => {
    return {
      Month:volume.volumeDate!=null?this.convertDateFormat(volume.volumeDate):volume.volumeDate,
      'Invoice Amount': volume.invoiceAmount != null ? volume.invoiceAmount : '--',
      'Volume Update Status':volume.statusName,
      'Product Applicability':volume.productApplicability=="true"||volume.productApplicability==true?'Yes':'No',
      'Data Entry Method': (volume.productApplicability === null || volume.productApplicability === false || volume.productApplicability === 'false')
        ? 'N/A'
        : (volume.dataEntry === true || volume.dataEntry === 'true')
          ? 'Upload File'
          : 'Manual Entry',
      'Override System Calculation': ([true, 'true'].includes(volume.productApplicability) && [true, 'true'].includes(volume.dataEntry))
        ? (volume.financeContractVolumeProducts?.every((p: { units: number | null }) => p.units === 0 || p.units === null) ? 'No' : 'Yes')
        : 'N/A',
      Attachments: volume.financeContractVolumeAttachments != null && volume.financeContractVolumeAttachments.length > 0
          ? volume.financeContractVolumeAttachments.map((att: { fileName: any; }) => att.fileName).join(', ') : 'N/A' ,
      'Modified By':this.privilegeService.getUserName(volume.updatedBy),
      'Modified Date and Time':volume.updatedDate!=null?this.convertDateTimeFormat(volume.updatedDate):volume.updatedDate,
    };
  });
  this.exportExcel(this.selectedRecordsToExpotToExcel);
}
convertDateFormat(inputDateTime: string) {
  const date = new Date(inputDateTime);
  const formattedDate = this.datePipe.transform(date, this._dateformart.MonthYearFormat);
  return formattedDate;
}
convertDateTimeFormat(inputDateTime: string) {  // while export to excel display UTC format
  const date = new Date(inputDateTime);

  // Adjust for timezone offset
  const timezoneOffsetHours = 5; 
  const timezoneOffsetMinutes = 30;
  date.setUTCHours(date.getUTCHours() + timezoneOffsetHours);
  date.setUTCMinutes(date.getUTCMinutes() + timezoneOffsetMinutes);

  // Format date
  const day = date.getUTCDate().toString().padStart(2, '0');
  const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
  const year = date.getUTCFullYear();
  const formattedDate = `${day}-${month}-${year}`;

  // Format time in UTC
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');
  const formattedTime = `${hours}:${minutes} UTC`;

  return `${formattedDate} ${formattedTime}`;
}

onInvoiceEdit(item: any) {
  this.editButtonClick.emit(item.id);
}
getFormattedValue(value: number, currencyName: string): string {
  return this.currencyService.getFormattedValue(value, currencyName);
}

  _contractDetail= new ContracDetails();
  contractInfo:any;
  _contractVolumeListData: any[] = []
	GetContractDetailsByContractId(contractId:number) {
      this.loaderService.showLoader();
      this.contractService.GetContractDtailsById(contractId).subscribe(res => {
        if (res.data != null) {
          this.contractInfo = res.data;
          if(this.contractInfo!=null && this.contractInfo!=undefined){
            this._contractDetail.contractDetailId=this.contractInfo.id;
            this._contractDetail.contractStartDate= this.datePipe.transform(this.contractInfo.startDate, "MM/dd/yyyy");
            this._contractDetail.contractEndDate=this.datePipe.transform(this.contractInfo.endDate, "MM/dd/yyyy");
          }
          this.GetContractVolumeByContractId(this._contractDetail);
        }
      
      });
    }

      GetContractVolumeByContractId(contractDetail:any){
      this._financeInvoiceService.GetContractVolumeByContractId(contractDetail).subscribe(
        response=>{
         this._contractVolumeListData=response.data;
           this.filteredRecordCount=this._contractVolumeListData.length;
           this.totalRecordCount=this._contractVolumeListData.length;
        this._contractVolumeListData.forEach(u => {
        u.updatedByName = this.privilegeService.getUserName(u.updatedBy);
        u.createdByName = this.privilegeService.getUserName(u.createdBy);
        u.statusName = this.getVolumeStatus(u.statusMappingId, u.invoiceAmount);
         u.InvoiceValue = u.invoiceAmount != null ? this.getFormattedValue(u.invoiceAmount, this.currency) : null;
        });
         this.loaderService.hideLoader();
            this.tabAndStateService.setVolumeData( this._contractVolumeListData);
        });
    }
	

getVolumeStatus(statusId?: number, invoiceAmount?: number): string {
  if (invoiceAmount != null && statusId === 0) {
    const pendingStatus = this.statusData.find((s: { name: string }) => s.name?.toLowerCase() === 'pending');
    return pendingStatus ? pendingStatus.name : 'Pending';
  }

  if (statusId) {
    const status = this.statusData.find((s: { id: number }) => s.id === statusId);
    if (status) return status.name;
  }

  const notApplicableStatus = this.statusData.find((s: { name: string }) => s.name?.toLowerCase() === 'not applicable');

  return notApplicableStatus ? notApplicableStatus.name : 'Not Applicable';
}

viewVolume(currentVolumeData:any){
       if (currentVolumeData?.productApplicability == null) {
    currentVolumeData.productApplicability = this.productApplicability;
  }
    const payload = {
      contractId:this.ContractId,
      volumeId: currentVolumeData
    };
    this.viewButtonClick.emit(payload);
  }
  convertFileDateFormat(inputDateTime: string) {
  const date = new Date(inputDateTime);
  const formattedDate = this.datePipe.transform(date, this._dateformart.GridDateFormat);
  return formattedDate;
}

  editVolume(currentVolumeData:any){
     if (currentVolumeData?.productApplicability == null) {
    currentVolumeData.productApplicability = this.productApplicability;
  }
    const data = {
      contractId:this.ContractId,
      volumeId: currentVolumeData
    };
    this.editButtonClick.emit(data);
  }

}
